import _ from 'underscore';

if (!window._) {
    window._ = _;
}

export default window._;



// WEBPACK FOOTER //
// src/js/aui/underscore.js